import type React from "react";

import type { SimpleProjectDto } from "@/api/types";
import { Building04Icon } from "@/components/Icons/Building04Icon";
import { Download01Icon } from "@/components/Icons/Download01Icon";
import { PageGrid } from "@/components/PageGrid/PageGrid";
import { PillList } from "@/components/Pill/PillList";
import { Button } from "@/design-system/Button";
import { SectionCard } from "@/design-system/SectionCard";
import { Stack } from "@/design-system/Stack";
import { useTranslation } from "@/translations";

interface BulkUploadAddressesInstructionViewProps {
  permittedProjects: SimpleProjectDto[];
  onDownloadExampleFile: () => void;
}

export function BulkUploadAddressesInstructionView({
  permittedProjects,
  onDownloadExampleFile,
}: BulkUploadAddressesInstructionViewProps): React.ReactNode {
  const { t } = useTranslation();

  return (
    <PageGrid.Column size="100%">
      <SectionCard>
        <Stack gap="md">
          <p className="text-body">{t("page.portfolio-address-bulk-upload.permitted-projects")}</p>
          <PillList
            label={t("common.entity.project", {
              count: permittedProjects.length,
            })}
            items={permittedProjects.map((project) => ({
              label: project.name,
              icon: <Building04Icon />,
            }))}
            maxShown={5}
          />
        </Stack>
        <p className="whitespace-pre-wrap">{t("page.portfolio-address-bulk-upload.prose")}</p>
        <Button variant="ghostPrimary" icon={<Download01Icon />} onClick={onDownloadExampleFile}>
          {t("page.portfolio-address-bulk-upload.btn.download-example-file")}
        </Button>
      </SectionCard>
    </PageGrid.Column>
  );
}
